export class RemittanceFilters {
  numbers?: string[];
  dateFrom?: string;
  dateTo?: string;
  accountNames?: string[];
  statuses?: string[];
  invoiceNumbers?: string[];
}
